export default "__VITE_ASSET__s2E5F34i__"